import { render, staticRenderFns } from "./flowInstanceApply.vue?vue&type=template&id=37bc8d6a&scoped=true"
import script from "./flowInstanceApply.vue?vue&type=script&lang=js"
export * from "./flowInstanceApply.vue?vue&type=script&lang=js"
import style0 from "./flowInstanceApply.vue?vue&type=style&index=0&id=37bc8d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc8d6a",
  null
  
)

export default component.exports